module.exports = __webpack_public_path__ + "img/ruan2.50455ad0.jpg";